import { Component, Inject, Input, OnInit } from '@angular/core';
import { StudentDeduplicationService } from '../../service/student-deduplication.service';
import { StudentMergedTree } from '../../model/student-merged-tree';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChildrenDeduplicationCompareModalComponent } from '../children-deduplication-compare-btn/children-deduplication-compare-modal/children-deduplication-compare-modal.component';

@Component({
    selector: 'view-children-merge-tree',
    templateUrl: './view-children-merge-tree.component.html',
    styleUrl: './view-children-merge-tree.component.scss'
})
export class ViewChildrenMergeTreeComponent implements OnInit {
    @Input() studentId!: number;
    @Input() studentMsdNumber!: string;

    studentMergedTree: StudentMergedTree;

    promises: any[] = [];
    isLoading: boolean = true;

    constructor(
        public studentDeduplicationService: StudentDeduplicationService,
        public dialogRef: MatDialogRef<ChildrenDeduplicationCompareModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        if (this.data) {
            this.studentId = this.data.studentId;
            this.studentMsdNumber = this.data.studentMsdNumber;
        }

        this.getStudentMergedTree();

        Promise.all(this.promises).then((res) => {
            this.isLoading = false;
        });
    }

    getStudentMergedTree() {
        let deferred = new Promise((resolve, reject) => {
            this.studentDeduplicationService.getStudentMergedTree(this.studentId).subscribe((res) => {
                if (res.studentMergedTree) {
                    this.studentMergedTree = res.studentMergedTree;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    resolve('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    closeDialog(closed: boolean) {
        this.data = { closed: closed };
        this.dialogRef.close(this.data);
    }
}
